import { inicioGuard, moduloGuard } from '@intelishs-group/session-core';
import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    // Al entrar: la PRIMERA pantalla del acceso (el primer módulo por su orden en identidad),
    // no un destino fijo.
    path: '',
    pathMatch: 'full',
    canActivate: [inicioGuard()],
    children: [],
  },
  {
    path: 'videoteca',
    canActivate: [moduloGuard('videoteca')],
    loadComponent: () => import('./pages/videoteca/videoteca.page').then((m) => m.VideotecaPage),
  },
  {
    path: 'videoteca/:idVideo',
    canActivate: [moduloGuard('videoteca')],
    loadComponent: () =>
      import('./pages/videoteca/video-detalle.page').then((m) => m.VideoDetallePage),
  },
  {
    path: 'etiquetas',
    loadComponent: () => import('./pages/etiquetas/etiquetas.page').then((m) => m.EtiquetasPage),
  },
  {
    // Una pantalla más. Iba sin guard porque era el destino de `rutaSinPermiso`; la aplicación
    // `videoteca` no tiene el módulo `dashboard`, así que hoy no la abre nadie (tampoco estaba
    // en el menú).
    path: 'dashboard',
    canActivate: [moduloGuard('dashboard')],
    loadComponent: () => import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
  },
  {
    // Lo que no existe vuelve a la primera pantalla del acceso. `children: []` y no
    // `redirectTo`: una redirección no corre guards.
    path: '**',
    canActivate: [inicioGuard()],
    children: [],
  },
];
